(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    const header = document.getElementById('nav-bar');
    const onHomePage = window.location.pathname == "/" ? true : false;
    const deskNavItems = document.getElementById('desk-nav');
    const wordmark = document.getElementById('wordmark');
    const headerHeight = document.getElementById('nav-bar').offsetHeight;

    const htmlElement = document.querySelector('html');
    if (window.location.pathname.includes('/products/')) {
      htmlElement.classList.add('dark');
    }
    if (window.location.pathname.includes('/products_preview')) {
      htmlElement.classList.add('dark');
    }
    
    if (onHomePage) {
      header.classList.remove('bg-gray-800');
      // wordmark.classList.remove('text-font-dark');
    }

    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 100) {
          let currentScroll = window.pageYOffset;
          if (onHomePage) {
            header.classList.add('bg-gray-800');
            // wordmark.classList.add('text-font-dark');
            deskNavItems.classList.add('text-black');
            deskNavItems.classList.remove('text-white');
          }
          if (!this.menuVisible) {
              if (currentScroll - this.lastScroll > 0) {
                  header.classList.add('scroll-down');
                  header.classList.remove('scroll-up');
                  header.style.cssText = ``;
              } else {
                  // scrolled up -- header show
                  header.classList.add('scroll-up');
                  header.classList.remove('scroll-down');
      
                  header.style.cssText = `position:fixed;top:0;z-index:100;`;
              }
          }
          this.lastScroll = currentScroll;
      } else {
        if (onHomePage) {
          header.classList.remove('bg-gray-800');
          // wordmark.classList.remove('text-font-dark');
          deskNavItems.classList.remove('text-black');
          deskNavItems.classList.add('text-white');
        }
      }
  });

  const mobile_toggle = document.getElementById('mobile-menu-toggle');
  const main = document.querySelector('main');
  let mobile_open = false;
  let lastScroll = 0;
  let top = 0;

  mobile_toggle.addEventListener('click', () => {
    const hamburger = document.getElementsByClassName('hamburger')[0];
    hamburger.classList.toggle('is-active');
    const mobile_menu = document.getElementById('mobile-menu');
    mobile_menu.classList.toggle('hidden');

    mobile_open = !mobile_open;
    if (mobile_open) {
      document.body.style.top = `-${window.pageYOffset}px`;
      top = window.pageYOffset;
      document.body.classList.add('fixed');
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('fixed');
      document.body.classList.remove('mobile-menu-open');
      document.body.style.cssText = '';
      window.scrollTo(0, top);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
